import React from 'react';
import { Badge, IconButton } from '@mui/material';
import type { FilterOperators } from '../types';
import { getOperatorIcon } from '../utils';
import { operatorButtonSx } from './filterLayoutStyles';

type OperatorIconButtonProps = {
  columnId: string;
  filterOperators: FilterOperators;
  filterValue: string | undefined;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

/**
 * Operator menu trigger button.
 * Shows a red dot badge when:
 * - A operator is selected for this column, OR
 * - A filter value exists for this column
 *
 * The badge is hidden only when both operator and value are empty/null
 */
export const OperatorIconButton = ({
  columnId,
  filterOperators,
  filterValue,
  onClick,
}: OperatorIconButtonProps) => {
  const operator = filterOperators?.[columnId];

  // Check if there's an active operator or filter value
  const hasOperator = operator != null && operator !== '';
  const hasValue = filterValue != null && filterValue !== '' && filterValue !== undefined;

  // Badge is visible when either operator or value is set
  const isActive = hasOperator || hasValue;

  return (
    <Badge
      color="error"
      variant="dot"
      invisible={!isActive}
      sx={{
        flexShrink: 0,
        '& .MuiBadge-dot': {
          width: 7,
          height: 7,
          minWidth: 7,
          top: 3,
          right: 3,
        },
      }}
    >
      <IconButton size="small" onClick={onClick} sx={operatorButtonSx}>
        {getOperatorIcon(operator)}
      </IconButton>
    </Badge>
  );
};
